import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

interface Tab {
  id: number;
  label: string;
  content: React.ReactNode;
  disabled?: boolean;
}

interface TabsProps {
  tabs: Tab[];
}

const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(() => (tabs.length > 0 ? tabs[0].id : null));
  
 // botones cabecera 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 10);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);
    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scrollByAmount = (direction: "left" | "right") => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.6;
    el.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <div className="w-full rounded-lg bg-white n-elevation-1 h-full ">
      {/* Encabezado de Tabs */}
       <div className="relative no-scrollbar flex items-center border-b p-2 pb-0">
        {/* Botón izquierda */}
        {showLeft && (
          <button
            onClick={() => scrollByAmount("left")}
            className="absolute left-0 z-20 h-10 w-10 flex items-center justify-center
                       bg-white/90 hover:bg-blue-100 text-blue-600 rounded-full shadow-md
                       transition-all duration-200 hover:scale-105"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
        )}

        {/* Contenedor scrollable de tabs */}
        <div
          ref={scrollRef}
          className="flex overflow-x-auto no-scrollbar scroll-smooth space-x-2 px-0 w-full"
          role="tablist"
        >
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => !tab.disabled && setActiveTab(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`whitespace-nowrap px-4 py-3 text-sm font-medium border-b-2 rounded-t-md transition-all duration-300
                ${
                  activeTab === tab.id
                    ? "border-blue-600 text-blue-600 bg-blue-50 shadow-inner"
                    : "border-transparent text-gray-500 hover:text-blue-600 hover:bg-gray-50"
                }
                ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}
              `}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Botón derecha */}
        {showRight && (
          <button
            onClick={() => scrollByAmount("right")}
            className="absolute right-0 z-20 h-10 w-10 flex items-center justify-center
                       bg-white/90 hover:bg-blue-100 text-blue-600 rounded-full shadow-md
                       transition-all duration-200 hover:scale-105"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        )}
      </div>




      {/* Contenedor del contenido con animación y tamaño dinámico */}
      <div className="overflow-hidden transition-all duration-500 ease-in-out p-4 h-full">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`w-full transition-all duration-500 ease-in-out  h-full
              ${activeTab === tab.id ? " opacity-100  " : " opacity-0 hidden"}
              `}
          >
            {/*activeTab === tab.id ? "opacity-100 scale-100 translate-y-0 relative" : "opacity-0 scale-95 -translate-y-0 pointer-events-none "*/}
            {tab.content}
          </div> 

        ))}
      </div>

    </div>
  );
};

export default Tabs;
